import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

export const DeleteConfirmationBox = ({ message, handleConfirm, handleCancel }) => {
  return (
    <Dialog
      open={true}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1
        }
      }}
    >
      <DialogTitle sx={{ pb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              bgcolor: 'error.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <WarningIcon sx={{ color: 'white', fontSize: 24 }} />
          </Box>
          <Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
              Confirm Deletion
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This action cannot be undone
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 0, pb: 2 }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body1">
            {message}
          </Typography>
        </Alert>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={handleCancel}
          variant="outlined"
          color="inherit"
          sx={{ 
            minWidth: 100,
            fontWeight: 500
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          sx={{ 
            minWidth: 100,
            fontWeight: 500
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const ConfirmationBox = ({message, handleConfirm, handleCancel}) => {

    return (
        <div style={{backgroundColor: '#fff', border: "2px solid #545454", borderRadius: '15px', position: 'absolute', top: '0', bottom: '10%', margin:'auto 0', height: 'fit-content', width: '100%', zIndex: '1000', padding: '10px'}}>
            <h2 className="h2-style">Warning</h2>
            <p className="p-style" style={{margin: '10px 0'}}>{message}</p>
            <div className='bottom-buttons'>
                <Button
                    style={{margin: "15px 5px 5px", width: '100px'}}
                    onClick={handleConfirm}
                    variant="contained"
                >
                    Yes
                </Button>

                <Button
                    style={{margin: "15px 5px 5px", width: '100px'}}
                    onClick={handleCancel}
                    variant="contained"
                >
                    No
                </Button>
            </div>
        </div>
    )
}


// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Box,
//   Alert
// } from '@mui/material';
// import WarningIcon from '@mui/icons-material/Warning';
// import InfoIcon from '@mui/icons-material/Info';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ErrorIcon from '@mui/icons-material/Error';

// interface ConfirmationBoxProps {
//   message: string;
//   handleConfirm: () => void;
//   handleCancel: () => void;
//   title?: string;
//   subtitle?: string;
//   type?: 'warning' | 'info' | 'success' | 'error';
//   confirmText?: string;
//   cancelText?: string;
//   confirmColor?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
// }

// export const ConfirmationBox = ({ 
//   message, 
//   handleConfirm, 
//   handleCancel,
//   title = "Confirm Action",
//   subtitle = "Please confirm your choice",
//   type = "warning",
//   confirmText = "Confirm",
//   cancelText = "Cancel",
//   confirmColor = "primary"
// }: ConfirmationBoxProps) => {
  
//   const getIcon = () => {
//     switch (type) {
//       case 'info':
//         return <InfoIcon sx={{ color: 'white', fontSize: 24 }} />;
//       case 'success':
//         return <CheckCircleIcon sx={{ color: 'white', fontSize: 24 }} />;
//       case 'error':
//         return <ErrorIcon sx={{ color: 'white', fontSize: 24 }} />;
//       case 'warning':
//       default:
//         return <WarningIcon sx={{ color: 'white', fontSize: 24 }} />;
//     }
//   };

//   const getIconBgColor = () => {
//     switch (type) {
//       case 'info':
//         return 'info.main';
//       case 'success':
//         return 'success.main';
//       case 'error':
//         return 'error.main';
//       case 'warning':
//       default:
//         return 'warning.main';
//     }
//   };

//   const getAlertSeverity = () => {
//     switch (type) {
//       case 'info':
//         return 'info';
//       case 'success':
//         return 'success';
//       case 'error':
//         return 'error';
//       case 'warning':
//       default:
//         return 'warning';
//     }
//   };

//   return (
//     <Dialog
//       open={true}
//       onClose={handleCancel}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: 2,
//           p: 1
//         }
//       }}
//     >
//       <DialogTitle sx={{ pb: 2 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//           <Box
//             sx={{
//               width: 48,
//               height: 48,
//               borderRadius: '50%',
//               bgcolor: getIconBgColor(),
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center'
//             }}
//           >
//             {getIcon()}
//           </Box>
//           <Box>
//             <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
//               {title}
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               {subtitle}
//             </Typography>
//           </Box>
//         </Box>
//       </DialogTitle>

//       <DialogContent sx={{ pt: 0, pb: 2 }}>
//         <Alert severity={getAlertSeverity()} sx={{ mb: 2 }}>
//           <Typography variant="body1">
//             {message}
//           </Typography>
//         </Alert>
//       </DialogContent>

//       <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//         <Button
//           onClick={handleCancel}
//           variant="outlined"
//           color="inherit"
//           sx={{ 
//             minWidth: 100,
//             fontWeight: 500
//           }}
//         >
//           {cancelText}
//         </Button>
//         <Button
//           onClick={handleConfirm}
//           variant="contained"
//           color={confirmColor}
//           sx={{ 
//             minWidth: 100,
//             fontWeight: 500
//           }}
//         >
//           {confirmText}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export const DeleteConfirmationBox = ({ message, handleConfirm, handleCancel }) => {
//   return (
//     <ConfirmationBox
//       message={message}
//       handleConfirm={handleConfirm}
//       handleCancel={handleCancel}
//       title="Confirm Deletion"
//       subtitle="This action cannot be undone"
//       type="error"
//       confirmText="Delete"
//       confirmColor="error"
//     />
//   );
// };